const menu = {
    label: 'Mão de Obra Temporária',
    icon: 'pi pi-fw pi-briefcase',
    to: '/solicitacoes/mao-de-obra-temporaria',
    matchChildren: true,
    rules: ['TEMPORARIO-00'],
};

export default menu;

